import { ListenerType } from 'features/sport';
import { updateQuoteFromSignalR, updateRisultatiniFromSignalR } from 'features/sport/components/sportTicket/sportTicketActions';
import {
  addAvvenimentoFromTicket,
  removeAvvenimentoFromTicket,
  updateScommesseAvvenimentoFromTicket,
  updateStatoInfoAggFromTicket,
} from './sportTicketSlice';

export { SportTicket } from './SportTicket';

export const signalRListeners: ListenerType<any>[] = [
  { eventName: 'UpdateTranslation' },
  {
    eventName: 'UpdateQuote',
    action: updateQuoteFromSignalR, // Aggiorna la cache delle items
  },
  { eventName: 'UpdateRisultatini', action: updateRisultatiniFromSignalR },
  { eventName: 'AddInfoAgg', actionType: updateStatoInfoAggFromTicket.type },
  { eventName: 'UpdateInfoAgg', actionType: updateStatoInfoAggFromTicket.type },
  {
    eventName: 'AddAvvenimento', // raro
    actionType: addAvvenimentoFromTicket.type,
  },
  { eventName: 'RemoveAvvenimento', actionType: removeAvvenimentoFromTicket.type },
  // { eventName: 'UpdateStatoInfoAgg', actionType: updateStatoInfoAggFromTicket.type },
  {
    eventName: 'UpdateScommesseAvvenimento', // raro
    actionType: updateScommesseAvvenimentoFromTicket.type,
  },
];